import React from "react";
import { twMerge } from "tailwind-merge";

interface ContainerProps {
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

const Container = ({ className, style, children }: ContainerProps) => {
  const containerClasses = `mx-auto max-w-screen-lg px-5 xl:px-0 ${
    className || ""
  }`;

  return (
    <div className={twMerge(containerClasses)} style={style}>
      {children}
    </div>
  );
};

export default Container;
